import TransactionUser from "./transaction-user.page";

export default TransactionUser;
